<div>
  <a href="javascript:void(0)" class="filter--dialog" role="button" tabindex="0" (click)="setDialogInfo('Asset class');assetClassFilterDialog.openModalDialog($event)"
    aria-label="What is asset class dialog title">What's an asset class?</a>
  <div class="filter--checkboxes">
    <div *ngFor="let label of assetClassFilterLabels">
      <c11n-checkbox [labelText]="filterMap[label].concat(' / ').concat(countByAssetClass(label))"
        [variant]="'default'" [descriptiveLabel]="'Extra checkbox content'" (change)="handleAssetClass($event, label)"
        [labelWeight]="'normal'">
        <input c11nCheckboxInput [id]="label" type="checkbox" name="choices" [value]="label"
          [formControl]="assetClassGroup.controls[label]">
      </c11n-checkbox>
      <div [ngSwitch]="label">

        <div class="sub-filter" *ngSwitchCase="'equity'">
          <div *ngIf="isAssetClassSelected(label)">
            <a href="javascript:void(0)" class="filter--dialog" role="button" tabindex="0"
              (click)="setDialogInfo('Market capitalization');assetClassFilterDialog.openModalDialog($event);" aria-label="What is market capitalization dialog title">
              Market capitalization</a>
            <c11n-checkbox-group>
              <c11n-checkbox *ngFor="let marketCap of marketCapitalFilterLabels" [labelText]="filterMap[marketCap]"
                [variant]="'default'" [descriptiveLabel]="'Extra checkbox content'" [labelWeight]="'normal'">
                <input c11nCheckboxInput [id]="marketCap" type="checkbox" name="choices" [value]="marketCap"
                  [formControl]="assetClassMarketCapGroup[label].controls[marketCap]">
              </c11n-checkbox>
            </c11n-checkbox-group>
            <a href="javascript:void(0)" class="filter--dialog" role="button" tabindex="0"
              (click)="setDialogInfo('Style');assetClassFilterDialog.openModalDialog($event);" aria-label="What is style dialog title">Style</a>
            <c11n-checkbox-group>
              <c11n-checkbox *ngFor="let style of styleFilterLabels" [labelText]="filterMap[style]" [variant]="'default'"
                [descriptiveLabel]="'Extra checkbox content'" [labelWeight]="'normal'">
                <input c11nCheckboxInput [id]="style" type="checkbox" name="choices" [value]="style"
                  [formControl]="assetClassStyleGroup[label].controls[style]">
              </c11n-checkbox>
            </c11n-checkbox-group>
          </div>
        </div>

        <div class="sub-filter" *ngSwitchCase="'fixed_income'">
          <div *ngIf="isAssetClassSelected(label)">
            <a href="javascript:void(0)" class="filter--dialog" role="button" tabindex="0"
              (click)="setDialogInfo('Credit Quality');assetClassFilterDialog.openModalDialog($event);" aria-label="What is credit quality title">Credit Quality</a>
            <c11n-checkbox-group>
              <c11n-checkbox *ngFor="let credit of creditQualityFilterLabels" [labelText]="filterMap[credit]" [variant]="'default'"
                [descriptiveLabel]="'Extra checkbox content'" [labelWeight]="'normal'">
                <input c11nCheckboxInput [id]="credit" type="checkbox" name="choices" [value]="credit"
                  [formControl]="assetClassCreditQualityGroup[label].controls[credit]">
              </c11n-checkbox>
            </c11n-checkbox-group>
            <a href="javascript:void(0)" class="filter--dialog" role="button" tabindex="0"
              (click)="setDialogInfo('Maturity');assetClassFilterDialog.openModalDialog($event);" aria-label="What is maturity title">Maturity</a>
            <c11n-checkbox-group>
              <c11n-checkbox *ngFor="let maturity of maturityFilterLabels" [labelText]="filterMap[maturity]" [variant]="'default'"
                [descriptiveLabel]="'Extra checkbox content'" [labelWeight]="'normal'">
                <input c11nCheckboxInput [id]="'maturity' + maturity" type="checkbox" name="choices" [value]="maturity2"
                  [formControl]="assetClassMaturityGroup[label].controls[maturity]">
              </c11n-checkbox>
            </c11n-checkbox-group>
          </div>
        </div>

        <div *ngSwitchDefault></div>
      </div>
    </div>

  </div>
</div>
<c11n-modal-dialog
  modalId="assetClassFilterDialog"
  [headingText]="dialogTitle"
  #assetClassFilterDialog
>
  <div c11n-modal-dialog-body>
    <p class="rps-paragraph-one" id="whatisAssetClassDialogDesc"
      [innerHtml]="formatLink(popupDescription?.contentValue)"
      attr.data-aem-source="{{popupDescription?.isAEM | json}}"></p>
  </div>
</c11n-modal-dialog>
